import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as engineerApi from "./api";

const KEY = "engineer";

export function useTodaysJobs() {
  return useQuery({
    queryKey: [KEY, "today"],
    queryFn: engineerApi.todaysJobs,
    // An engineer's list changes as dispatch assigns work; a stale board is
    // worse than a slightly chatty one.
    refetchInterval: 60_000,
  });
}

function useInvalidate() {
  const qc = useQueryClient();
  return () => {
    void qc.invalidateQueries({ queryKey: [KEY] });
    void qc.invalidateQueries({ queryKey: ["tickets"] });
  };
}

export function useCheckIn() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: ({
      ticketId,
      body,
    }: {
      ticketId: string;
      body: Parameters<typeof engineerApi.checkIn>[1];
    }) => engineerApi.checkIn(ticketId, body),
    onSuccess: invalidate,
  });
}

export function useCheckOut() {
  const invalidate = useInvalidate();
  return useMutation({ mutationFn: engineerApi.checkOut, onSuccess: invalidate });
}

export function useServiceReport(ticketId: string | null) {
  return useQuery({
    queryKey: [KEY, "report", ticketId],
    queryFn: () => engineerApi.getServiceReport(ticketId as string),
    enabled: ticketId !== null,
  });
}

export function useCreateServiceReport() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: ({
      ticketId,
      body,
    }: {
      ticketId: string;
      body: Parameters<typeof engineerApi.createServiceReport>[1];
    }) => engineerApi.createServiceReport(ticketId, body),
    onSuccess: invalidate,
  });
}
